module.exports = __webpack_public_path__ + "media/bootstrap-icons/backspace-reverse-3da7c7e0.svg";